import React from "react";
import { Col, Row } from "antd";
import AreaAddModal from "./AreaAddModal";
import { useAuth, userActiveView } from "../../utils/Auth";
import { ListMenu } from "../../common/components/ListMenu";

export const AreaListMenu = ({ search, setSearch, reload }) => {
  const { user } = useAuth();

  return (
    <div>
      <ListMenu search={search} setSearch={setSearch} />
      <Row justify="space-between" style={{ justifyContent: "flex-end" }}>
        {userActiveView(user) && (
          <Col span={8} offset={8} style={{ textAlign: "right" }}>
            <AreaAddModal reload={reload} />
          </Col>
        )}
      </Row>
    </div>
  );
};
